import dayjs from 'dayjs';

export const SAMPLING_BOUNDARY_TOLERANCE_MIN = 10;

export const hoursBetween = (start: dayjs.Dayjs, end: dayjs.Dayjs): number => {
  return end.diff(start, 'minute') / 60;
};

export const countDosesBeforeSwitch = (start: dayjs.Dayjs, next: dayjs.Dayjs, interval: number): number => {
  if (interval <= 0) return 1;
  const diffH = hoursBetween(start, next);
  if (diffH <= 0) return 1;
  const epsilon = 1e-9;
  return Math.max(1, Math.floor(Math.max(diffH - epsilon, 0) / interval) + 1);
};

export const countDosesAtSampling = (
  start: dayjs.Dayjs,
  sample: dayjs.Dayjs,
  interval: number,
  toleranceMin = SAMPLING_BOUNDARY_TOLERANCE_MIN,
): number => {
  if (interval <= 0) return 1;
  const diffH = hoursBetween(start, sample);
  if (diffH <= 0) return 1;
  const toleranceH = Math.max(toleranceMin, 0) / 60;
  const epsilon = 1e-9;
  return Math.max(1, Math.floor(Math.max(diffH - toleranceH - epsilon, 0) / interval) + 1);
};
